"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var __1 = require("../..");
var button_1 = require("../../components/button/button");
var helpButton_1 = require("../../components/button/helpButton");
var UserProfilePage = /** @class */ (function (_super) {
    __extends(UserProfilePage, _super);
    function UserProfilePage(api, navigator, currentUserManager) {
        var _this = _super.call(this, __1.PageTypes.UserProfile, 'User Profile') || this;
        _this.api = api;
        _this.navigator = navigator;
        _this.currentUserManager = currentUserManager;
        _this.goToHistoryPage = function () {
            _this.navigator.goToHistoryPage({ historyType: __1.HistoryTypes.UserHistory, recordId: _this.currentUserManager.userId });
        };
        _this.formInvalid = function () {
            _this.saveButton.setProcessing(false);
        };
        _this.load = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b, i;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this._isLoading = true;
                        _b = (_a = this._form).setModel;
                        return [4 /*yield*/, this.api.get(__1.EndpointUrls.Users + '/UserProfile')];
                    case 1:
                        _b.apply(_a, [_c.sent()]);
                        this._hotelRewardsForm.setHotelRewardNumbers(this.form.model.hotelRewardNumbers);
                        for (i = 0; i < this._userPreferencesForm.fields.length; i++) {
                            this._userPreferencesForm.fields[i].setValue(this._form.model[this._userPreferencesForm.fields[i].key]);
                        }
                        this._isLoading = false;
                        this.observationProvider.notifyObservers(__1.UserProfilePageActions.RecordLoaded);
                        return [2 /*return*/];
                }
            });
        }); };
        _this.submit = function () {
            if (!_this._form.isValid()) {
                return;
            }
            _this._form.model.hotelRewardNumbers = _this._hotelRewardsForm.getHotelRewardNumbers();
            _this._userPreferencesForm.submit();
            for (var i = 0; i < _this._userPreferencesForm.fields.length; i++) {
                _this._form.model[_this._userPreferencesForm.fields[i].key] = _this._userPreferencesForm.fields[i].value;
            }
            _this.currentUserManager.updateUserPreferences(_this._userPreferencesForm.model);
            _this._form.submit();
        };
        _this.goBack = function () {
            _this.navigator.goBack();
        };
        _this.helpButton = new helpButton_1.default(__1.HelpUrlType.UserProfile, null, navigator, api);
        _this.observationProvider = new __1.ObservationProvider();
        _this.buildForm();
        _this._form.observationProvider.observe(function (submissionFailure) {
            _this.alert.show({
                alertType: __1.AlertType.Error,
                heading: 'Unable to save',
                message: submissionFailure.message
            });
            _this.observationProvider.notifyObservers(__1.UserProfilePageActions.Error);
        }, __1.SubmittableFormActions.SubmissionFailure);
        _this._form.observationProvider.observe(function () {
            _this.currentUserManager.updateProfileImageUrl(_this._form.model.profileImageUrl);
            _this.goBack();
        }, __1.SubmittableFormActions.RecordEdited);
        _this._hotelRewardsForm.observationProvider.observe(_this.load, __1.HotelRewardsFormActions.HotelsLoaded);
        _this.backButton = new button_1.default({
            text: 'Back',
            onClick: _this.navigator.goBack
        });
        _this.saveButton = new button_1.default({
            processingText: 'Submitting...',
            text: 'Submit',
            onClick: _this.submit
        });
        _this.historyButton = new button_1.default({
            onClick: _this.goToHistoryPage,
            leftIcon: __1.Icons.Clock
        });
        return _this;
    }
    Object.defineProperty(UserProfilePage.prototype, "form", {
        get: function () {
            return this._form;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserProfilePage.prototype, "isLoading", {
        get: function () {
            return this._isLoading;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserProfilePage.prototype, "hotelRewardsForm", {
        get: function () {
            return this._hotelRewardsForm.fields;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserProfilePage.prototype, "userPreferencesForm", {
        get: function () {
            return this._userPreferencesForm;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserProfilePage.prototype, "isApp", {
        get: function () {
            return this.currentUserManager.clientChecker.isMobileApp();
        },
        enumerable: false,
        configurable: true
    });
    UserProfilePage.prototype.buildForm = function () {
        this._hotelRewardsForm = new __1.HotelRewardsForm(this.api);
        this._userPreferencesForm = new __1.Form([
            new __1.CheckBoxField('defaultMyMeetingsFilterEnabled', 'Default to show only my meetings in the meeting list', false),
            new __1.CheckBoxField('defaultMeetingScheduleEnabled', 'Default to My Meeting Schedule', false),
            new __1.CheckBoxField('defaultMyBusinessAreaFilterOnAttendeesTileEnabled', 'Show only My BA on Attendees tile', false)
        ]);
        var areaOfExpertiseNoSelectionLabel = null;
        if (!this.currentUserManager.areaOfExpertiseRequired) {
            areaOfExpertiseNoSelectionLabel = 'None';
        }
        var titleNoSelectionLabel = null;
        if (!this.currentUserManager.titleRequired) {
            titleNoSelectionLabel = 'None';
        }
        var fields = [
            new __1.FileInputField('profileImageUrl', 'Profile Image', false),
            new __1.TextField('firstName', 'First Name', true, 100, 'First name is required'),
            new __1.TextField('lastName', 'Last Name', true, 100, 'Last name is required'),
            new __1.EmailField('email', true, 'Login Email'),
            new __1.EmailField('contactEmail', true, 'Contact Email'),
            new __1.TextField('contactPhone', 'Mobile Phone', true, 50, 'required'),
            new __1.TextField('areaOfExpertise', 'Area of Expertise', this.currentUserManager.areaOfExpertiseRequired, 250, 'required', null),
            new __1.DepartmentDropdown(this.api, 'departmentId', true),
            new __1.LinesOfBusinessDropdown(this.api, 'lineOfBusinessId', false, null, 'None'),
            new __1.UserTitlesDropdown(this.api, 'userTitleId', 'Title', this.currentUserManager.titleRequired, 'required', false, null, titleNoSelectionLabel)
        ];
        this._form = new __1.SubmittableForm(__1.EndpointUrls.Users + '/UserProfile', this.api, fields);
        this._form.observationProvider.observe(this.formInvalid, __1.SubmittableFormActions.SubmissionFailure);
    };
    return UserProfilePage;
}(__1.BasePage));
exports.default = UserProfilePage;
